let language = {
    "menu:part:catalog": "目录",
    "route:newProduct": "新产品",

    "btn_signup": "注册",
    "btn_signin": "登录",
    "btn_signout": "退出",
}

export { language }